import axios from "axios";
import dashboard_requests from "../api/dashboard_requests";
import api_requests from "../api/api_requests";

export default {
    state: {
        errors: [],
        errorsObj: {},
        all_tickets: [],
        tickets_current_page: 1,
        ticket_pages_total: 1,
        ticket_messages: [],
        ticket_status: [],
        new_messages_exists: false,
    },
    getters: {
        getError:state => state.errors,
        getErrorObj: state => state.errorsObj,
        getAllTickets: state => state.all_tickets,
        getTicketsCurrentPage: state => state.tickets_current_page,
        getTicketsPagesTotal: state => state.ticket_pages_total,
        getTicketMessages: state => state.ticket_messages,
        getTicketStatus: state => state.ticket_status,
        ticketMessagesExists: state => state.new_messages_exists,
    },
    mutations: {
        CREATE_ERRORS(state, error) {
            state.errors.push(error)
        },
        CREATE_ERROR_OBJ(state, error) {
            state.errorsObj = error
        },
        RESET_ERROR_OBJ(state, errorName) {
            delete state.errorsObj[errorName]
            state.errorsObj = {...state.errorsObj}
        },
        RESET_ERRORS(state) {
            state.errors = []
            state.errorsObj = {}
        },
        SET_ALL_TICKETS(state, data) {
            state.tickets_current_page = data.current_page
            state.ticket_pages_total = data.last_page
            state.all_tickets = data.data
        },
        SET_TICKET_MESSAGES(state, data) {
            state.ticket_messages = data.messages
        },
        SET_TICKET_STATUS(state, data) {
            state.ticket_status = data.ticket_status
        },
        NEW_MESSAGES_EXISTS(state, boolean) {
            state.new_messages_exists = boolean
        }
    },
    actions: {
        resetError(ctx) {
            ctx.commit('RESET_ERRORS')
        },
        resetOneOfErrors(ctx, fieldName) {
            ctx.commit('RESET_ERROR_OBJ', fieldName)
        },
        handleCreateError(ctx) {
            ctx.commit('CREATE_ERRORS')
        },
        get_all_tickets(ctx, page = 1) {
            return new Promise((resolve, reject) => {
                api_requests.get_all_tickets(page)
                    .then((response) => {
                        ctx.commit('SET_ALL_TICKETS',response.data)
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },
        get_ticket_messages(ctx, data) {
            return new Promise((resolve, reject) => {
                api_requests.get_ticket_messages(data)
                    .then((response) => {
                        ctx.commit('SET_TICKET_MESSAGES', response.data)
                        ctx.commit('SET_TICKET_STATUS', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        get_ticket_topics() {
            return new Promise ((resolve, reject) => {
                dashboard_requests.get_ticket_topics()
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },
        create_ticket(ctx, data) {
            return new Promise ((resolve, reject) => {
                dashboard_requests.create_ticket(data)
                    .then(() => {
                        resolve()
                    })
                    .catch((error) => {

                        for (let i in error.response.data.error) {
                            ctx.commit('CREATE_ERRORS', error.response.data.error[i])
                        }
                        reject()
                    })
            })

        },
        create_ticket_message(ctx, data) {
            return new Promise ((resolve, reject) => {
                dashboard_requests.create_ticket_message(data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },
        create_feedback(ctx, data) {
            return new Promise ((resolve, reject) => {
                dashboard_requests.create_feedback(data)
                    .then(() => {
                        resolve()
                    })
                    .catch((error) => {
                        ctx.commit('CREATE_ERROR_OBJ', error.response.data.error)
                        for (let i in error.response.data.error) {
                            ctx.commit('CREATE_ERRORS', error.response.data.error[i])
                        }
                        reject(error)
                    })
            })
        },
        reset_counter_messages_for_ticket(ctx, data) {
            return new Promise((resolve, reject) => {
                api_requests.reset_counter_messages_for_ticket(data)
                    .then((response) => {
                        ctx.commit('NEW_MESSAGES_EXISTS', response.data.new_messages_exists)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })

        },
        check_new_messages(ctx, data) {
            return new Promise((resolve, reject) => {
                api_requests.check_new_messages()
                    .then((response) => {
                        ctx.commit('NEW_MESSAGES_EXISTS', response.data.new_messages_exists)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        }
    },

}
